import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  CircularProgress,
  Grid,
  Stack,
  Button,
  Tooltip,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import AuthContext from "../../store/AuthContext";
import { get, postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";

import FilterCard from "../../modals/FilterCard";
import ApiPaginateSearch from "../../component/ApiPaginateSearch";
import CreateProject from "../Biggbarains/CreateProject";
import CachedIcon from "@mui/icons-material/Cached";
import { CustomStyles } from "../../component/CustomStyle";
import useCommonContext from "../../store/CommonContext";
import DataFilter from "../Biggbarains/Common/DataFilter";
import FilterModal from "../../modals/FilterModal";
import { useMediaQuery, useTheme } from "@mui/material";
let refresh;
export const Projectdata = ({ users }) => {
  // const [users, setUsers] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("");
  const [isShowFilterCard, setIsShowFilterCard] = useState(false);
  const { chooseInitialCategoryFilter } = useCommonContext();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const authCtx = useContext(AuthContext);
  const user = authCtx.user;
  function refreshFunc(setQuery) {
    setQuery("");
    if (refresh) refresh();
  }
  return (
    <Box sx={{ justifyContent: "" }}>
      <Grid justifyContent="space-between" alignItems="center">
        {isSmallScreen ? (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <FilterModal
              ifProjectNameFilter
              ifPriorityFilter
              setQuary={setQuery}
              setQuery={setQuery}
              handleRefresh={refreshFunc}
            />
            {user.role === "Admin" && <CreateProject refresh={refresh} />}
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 4,
            }}
          >
            <DataFilter
              ifProjectNameFilter
              ifPriorityFilter
              setQuary={setQuery}
              handleRefresh={refreshFunc}
            />
            {user.role === "Admin" && <CreateProject refresh={refresh} />}
          </Box>
        )}

        <ApiPaginateSearch
          apiEnd={ApiEndpoints.GET_PROJECTS}
          card={true}
          pagename={"project"}
          refresh={refresh}
          apiData={apiData}
          setApiData={setApiData}
          tableStyle={CustomStyles}
          queryParam={query ? query : ""}
          returnRefetch={(ref) => {
            refresh = ref;
          }}
          isFilterAllowed={true}
        />
      </Grid>
    </Box>
  );
};
